// src/components/pages/TeamSports/BasketballEventsList.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    fetchUserBasketGames,
    createBasketGame,
    fetchPublicBasketGames,
} from "../../../../data-store/actions/teamgames-actions";

import {
    Box,
    Button,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";

const BasketballEventsPublicList = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const userId = useSelector((state) => state.atlete.userID);

    const teamgames = useSelector((state) => state.teamgames) || {};
    const events = teamgames.itemsLive || [];
    const loadingLive = teamgames.loadingLive || false;
    const error = teamgames.error || null;

    // Estado para el diálogo de nueva descripción
    const [openDialog, setOpenDialog] = useState(false);
    const [newDescription, setNewDescription] = useState("");

    useEffect(() => {
        if (userId) {
            dispatch(fetchPublicBasketGames());
        }
    }, [userId, dispatch]);

    const handleOpenCreateDialog = () => {
        if (!userId) return;
        setNewDescription("");
        setOpenDialog(true);
    };



    const handleOpenEvent = (eventId) => {
        history.push(`/basketball/${eventId}`);
    };

    if (!userId) {
        return (
            <Box p={2} style={{ margin: 100 }}>
                <Typography variant="h2">
                    Inicia sesión para ver los juegos activos de básquet.
                </Typography>
            </Box>
        );
    }

    return (
        <Box p={2}>
            <Box
                mb={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h5">Juegos de básquet activos</Typography>
            </Box>

            {loadingLive && (
                <Box display="flex" justifyContent="center" mt={2}>
                    <CircularProgress />
                </Box>
            )}

            {error && (
                <Box mt={2}>
                    <Typography color="error">Error: {error}</Typography>
                </Box>
            )}

            {!loadingLive && events.length === 0 && (
                <Box mt={2}>
                    <Typography>No hay juego activos actualmente</Typography>
                </Box>
            )}

            <List>
                {events.sort((a, b) => b.createdAt - a.createdAt).map((ev) => (
                    <ListItem
                        key={ev.id}
                        button
                        onClick={() => handleOpenEvent(ev.id)}
                    >
                        <ListItemText
                            primary={ev.name || "Juego sin nombre"}
                            secondary={ev.status ? `Estado: ${ev.status}` : null}
                        />
                    </ListItem>
                ))}
            </List>

        </Box>
    );
};

export default BasketballEventsPublicList;
